import React from 'react';

function BlogTopAgencySEO({ 
  city, 
  state = "Maharashtra",
  category = "Website Development",
  blogImage = "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1400&q=80",
  aashwayImage = "https://images.unsplash.com/photo-1551434678-e076c223a692?w=1400&q=80",
  keywords = "website development company, web development services, custom website, e-commerce development"
}) {
  const categoryData = {
    "Website Development": {
      badge: "Web Development",
      title: `Best Website Development Company in ${city} | Top Web Developers ${city} ${state}`,
      h2WhyNeed: `Why ${city} Businesses Need a Professional Website`,
      h2LookFor: "What to Look for in a Website Development Company in {city}",
      h2Top: "Top Website Development Companies in {city}",
      h2Services: "Services Offered by Website Development Companies in {city}",
      h2Choose: "How to Choose the Right Web Development Company in {city}",
      intro: "Looking for the best website development company in {city}? Your search ends here! In today's digital era, having a professional website is essential for business success. Whether you're a startup, small business, or established enterprise in {city}, a well-designed website helps you attract more customers, build credibility, and grow your revenue.",
      whyNeed: "{city}, {state} has emerged as a significant hub for digital transformation. With increasing internet penetration and smartphone usage, businesses in {city} are realizing the importance of having a strong online presence. This guide covers the top website development companies in {city} that can help you build a professional, SEO-friendly, and conversion-optimized website.",
      lookForItems: [
        { title: "Portfolio & Case Studies", desc: "Review their previous work to understand quality and diversity" },
        { title: "Technical Expertise", desc: "Ensure they work with modern technologies like React, WordPress, PHP, or Python" },
        { title: "SEO Knowledge", desc: "Websites must be built with SEO best practices for better Google rankings" },
        { title: "Responsive Design", desc: "Your site must work perfectly on mobile, tablet, and desktop" },
        { title: "Post-Launch Support", desc: "Choose a company offering maintenance and support" },
        { title: "Transparent Pricing", desc: "Clear pricing without hidden costs" }
      ],
      services: [
        { title: "Custom Website Development", desc: "Tailor-made websites built from scratch as per your business requirements" },
        { title: "E-Commerce Development", desc: "Online stores with secure payment gateways and inventory management" },
        { title: "WordPress Development", desc: "Easy-to-manage websites using WordPress CMS" },
        { title: "SEO Services", desc: "On-page and off-page SEO to rank higher on Google" },
        { title: "Website Maintenance", desc: "Regular updates, security patches, and technical support" },
        { title: "Mobile App Development", desc: "Native and cross-platform mobile applications" }
      ],
      tags: ['Custom Websites', 'E-Commerce', 'WordPress', 'SEO Services', 'Mobile Responsive'],
      conclusion: "Having a professional website is essential for business success in {city}'s competitive market."
    },
    "SEO": {
      badge: "SEO Services",
      title: `Best SEO Company in ${city} | Top SEO Services ${city} ${state}`,
      h2WhyNeed: `Why ${city} Businesses Need SEO Services`,
      h2LookFor: "What to Look for in an SEO Company in {city}",
      h2Top: "Top SEO Companies in {city}",
      h2Services: "Services Offered by SEO Companies in {city}",
      h2Choose: "How to Choose the Right SEO Company in {city}",
      intro: "Looking for the best SEO company in {city}? Your search ends here! In today's digital age, having a strong online presence is crucial for business success. Whether you're a startup, small business, or established enterprise in {city}, effective SEO services help you attract more customers, build credibility, and grow your revenue.",
      whyNeed: "{city}, {state} has emerged as a significant hub for digital marketing. With increasing internet penetration and smartphone usage, businesses in {city} are realizing the importance of search engine optimization. This guide covers the top SEO companies in {city} that can help you rank higher on Google and drive more organic traffic to your website.",
      lookForItems: [
        { title: "Proven Track Record", desc: "Check their case studies and client testimonials" },
        { title: "Technical SEO Expertise", desc: "Ensure they handle on-page, off-page, and technical SEO" },
        { title: "Transparent Reporting", desc: "Regular updates on rankings and traffic metrics" },
        { title: "White Hat Practices", desc: "Avoid companies using black hat techniques that can penalize your site" },
        { title: "Industry Experience", desc: "Choose a company with experience in your industry" },
        { title: "Custom Strategies", desc: "Avoid one-size-fits-all approaches" }
      ],
      services: [
        { title: "On-Page SEO", desc: "Optimization of website content and structure" },
        { title: "Off-Page SEO", desc: "Link building and external optimization" },
        { title: "Technical SEO", desc: "Website speed, mobile-friendliness, and crawlability" },
        { title: "Local SEO", desc: "Google My Business optimization and local citations" },
        { title: "Content Marketing", desc: "Blog posts, articles, and content strategy" },
        { title: "Keyword Research", desc: "Identifying high-value keywords for your business" }
      ],
      tags: ['On-Page SEO', 'Off-Page SEO', 'Local SEO', 'Technical SEO', 'Content Marketing'],
      conclusion: "SEO is essential for business success in {city}'s competitive digital market."
    },
    "Graphic Designing": {
      badge: "Graphic Design",
      title: `Best Graphic Designing Company in ${city} | Top Graphic Designers ${city} ${state}`,
      h2WhyNeed: `Why ${city} Businesses Need Professional Graphic Design`,
      h2LookFor: "What to Look for in a Graphic Designing Company in {city}",
      h2Top: "Top Graphic Designing Companies in {city}",
      h2Services: "Services Offered by Graphic Designing Companies in {city}",
      h2Choose: "How to Choose the Right Graphic Design Company in {city}",
      intro: "Looking for the best graphic designing company in {city}? Your search ends here! In today's visually-driven world, professional graphic design is essential for business success. Whether you're a startup, small business, or established enterprise in {city}, eye-catching designs help you attract customers, build brand identity, and stand out from competitors.",
      whyNeed: "{city}, {state} has emerged as a significant hub for creative industries. With increasing competition, businesses in {city} are realizing the importance of professional visual identity. This guide covers the top graphic designing companies in {city} that can help you create a strong brand presence through compelling visuals.",
      lookForItems: [
        { title: "Portfolio Quality", desc: "Review their previous work to understand style and creativity" },
        { title: "Brand Identity Expertise", desc: "Ensure they can create cohesive brand identities" },
        { title: "Versatility", desc: "Check their ability to design for various mediums" },
        { title: "Turnaround Time", desc: "Quick delivery without compromising quality" },
        { title: "Client Reviews", desc: "Check testimonials and ratings from past clients" },
        { title: "Competitive Pricing", desc: "Clear pricing that fits your budget" }
      ],
      services: [
        { title: "Logo Design", desc: "Unique logos that represent your brand identity" },
        { title: "Brand Identity", desc: "Complete brand packages including colors and typography" },
        { title: "Print Design", desc: "Business cards, brochures, and marketing materials" },
        { title: "Social Media Graphics", desc: "Engaging posts for social media platforms" },
        { title: "Website Graphics", desc: "Banners, icons, and UI elements" },
        { title: "Packaging Design", desc: "Attractive packaging for products" }
      ],
      tags: ['Logo Design', 'Brand Identity', 'Print Design', 'Social Media', 'Packaging'],
      conclusion: "Professional graphic design is essential for building a strong brand in {city}'s competitive market."
    },
    "Digital Marketing": {
      badge: "Digital Marketing",
      title: `Best Digital Marketing Company in ${city} | Top Digital Marketing Services ${city} ${state}`,
      h2WhyNeed: `Why ${city} Businesses Need Digital Marketing`,
      h2LookFor: "What to Look for in a Digital Marketing Company in {city}",
      h2Top: "Top Digital Marketing Companies in {city}",
      h2Services: "Services Offered by Digital Marketing Companies in {city}",
      h2Choose: "How to Choose the Right Digital Marketing Company in {city}",
      intro: "Looking for the best digital marketing company in {city}? Your search ends here! In today's digital era, effective marketing is essential for business success. Whether you're a startup, small business, or established enterprise in {city}, digital marketing services help you attract more customers, build brand awareness, and grow your revenue.",
      whyNeed: "{city}, {state} has emerged as a significant hub for digital transformation. With increasing internet penetration and smartphone usage, businesses in {city} are realizing the importance of digital marketing. This guide covers the top digital marketing companies in {city} that can help you reach your target audience and achieve business goals.",
      lookForItems: [
        { title: "Proven Results", desc: "Check case studies and client success stories" },
        { title: "Multi-Channel Expertise", desc: "Ensure they handle SEO, PPC, social media, and email marketing" },
        { title: "Data-Driven Approach", desc: "Look for companies using analytics and ROI tracking" },
        { title: "Industry Experience", desc: "Choose a company with experience in your sector" },
        { title: "Transparent Reporting", desc: "Regular updates on campaign performance" },
        { title: "Custom Strategies", desc: "Avoid one-size-fits-all marketing approaches" }
      ],
      services: [
        { title: "Search Engine Optimization", desc: "Improve organic search rankings" },
        { title: "Pay-Per-Click Advertising", desc: "Google Ads and social media advertising" },
        { title: "Social Media Marketing", desc: "Engage audiences on Facebook, Instagram, LinkedIn" },
        { title: "Email Marketing", desc: "Newsletter campaigns and automation" },
        { title: "Content Marketing", desc: "Blogs, videos, and infographics" },
        { title: "Analytics & Reporting", desc: "Track performance and optimize campaigns" }
      ],
      tags: ['SEO', 'PPC', 'Social Media', 'Email Marketing', 'Content Marketing'],
      conclusion: "Digital marketing is essential for business growth in {city}'s competitive market."
    },
    "Social Media Marketing": {
      badge: "Social Media",
      title: `Best Social Media Marketing Company in ${city} | Top SMM Services ${city} ${state}`,
      h2WhyNeed: `Why ${city} Businesses Need Social Media Marketing`,
      h2LookFor: "What to Look for in a Social Media Marketing Company in {city}",
      h2Top: "Top Social Media Marketing Companies in {city}",
      h2Services: "Services Offered by Social Media Marketing Companies in {city}",
      h2Choose: "How to Choose the Right Social Media Marketing Company in {city}",
      intro: "Looking for the best social media marketing company in {city}? Your search ends here! In today's connected world, social media presence is essential for business success. Whether you're a startup, small business, or established enterprise in {city}, effective social media marketing helps you engage with customers, build brand loyalty, and grow your business.",
      whyNeed: "{city}, {state} has emerged as a significant hub for social media activity. With millions of users on platforms like Facebook, Instagram, and LinkedIn, businesses in {city} are realizing the importance of social media marketing. This guide covers the top social media marketing companies in {city} that can help you build a strong online community.",
      lookForItems: [
        { title: "Platform Expertise", desc: "Ensure they have experience with relevant platforms" },
        { title: "Content Quality", desc: "Check the creativity and quality of their content" },
        { title: "Engagement Strategy", desc: "Look for companies that focus on audience engagement" },
        { title: "Analytics", desc: "Regular reporting on reach, engagement, and conversions" },
        { title: "Influencer Connections", desc: "Ability to leverage influencer partnerships" },
        { title: "Competitive Pricing", desc: "Clear pricing that fits your marketing budget" }
      ],
      services: [
        { title: "Social Media Strategy", desc: "Customized plans for each platform" },
        { title: "Content Creation", desc: "Posts, stories, reels, and videos" },
        { title: "Community Management", desc: "Responding to comments and messages" },
        { title: "Social Media Advertising", desc: "Targeted ads on social platforms" },
        { title: "Influencer Marketing", desc: "Partnering with relevant influencers" },
        { title: "Analytics & Reporting", desc: "Track performance and optimize strategies" }
      ],
      tags: ['Content Creation', 'Community Management', 'Paid Ads', 'Influencer Marketing', 'Analytics'],
      conclusion: "Social media marketing is essential for building brand awareness in {city}'s competitive market."
    }
  };

  const data = categoryData[category] || categoryData["Website Development"];
  const title = data.title.replace(`Best ${category} Company`, `Best ${category} Company`).replace(`Top ${category} Services`, `Top ${category} Services`).replace(`Top SMM Services`, `Top Social Media Marketing Services`);
  const h2LookFor = data.h2LookFor.replace("{city}", city);
  const h2Top = data.h2Top.replace("{city}", city);
  const h2Services = data.h2Services.replace("{city}", city);
  const h2Choose = data.h2Choose.replace("{city}", city);
  const intro = data.intro.replace(/{city}/g, city).replace(/{state}/g, state);
  const whyNeed = data.whyNeed.replace(/{city}/g, city).replace(/{state}/g, state);
  const conclusion = data.conclusion.replace(/{city}/g, city);
  return (
    <main className="main-bg">
      <section style={{ padding: '100px 20px 40px', backgroundColor: '#fff' }}>
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12" style={{ maxWidth: '1200px', margin: '0 auto' }}>
              <div style={{ marginBottom: '20px' }}>
                <span style={{
                  backgroundColor: '#000',
                  color: '#fff',
                  padding: '6px 16px',
                  borderRadius: '20px',
                  fontSize: '12px',
                  fontWeight: '600',
                  letterSpacing: '1px',
                  textTransform: 'uppercase'
                }}>
                  {data.badge}
                </span>
              </div>

              <h1 style={{
                fontSize: 'clamp(26px, 4vw, 42px)',
                fontWeight: '700',
                lineHeight: '1.25',
                color: '#111',
                marginBottom: '16px'
              }}>
                {title}
              </h1>

              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                color: '#666',
                fontSize: '14px',
                marginBottom: '30px',
                flexWrap: 'wrap'
              }}>
                <span>By <strong style={{ color: '#111' }}>Aashway Team</strong></span>
                <span>•</span>
                <span>April 2025</span>
                <span>•</span>
                <span>6 min read</span>
              </div>

              <div style={{
                width: '100%',
                borderRadius: '12px',
                marginBottom: '40px',
                backgroundColor: '#f5f5f5'
              }}>
                <img
                  src={blogImage}
                  alt={`Best ${category.toLowerCase()} company in ${city} - Aashway`}
                  style={{ width: '100%', height: 'auto', display: 'block' }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section style={{ paddingBottom: '60px', backgroundColor: '#fff' }}>
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12" style={{ maxWidth: '1200px', margin: '0 auto' }}>

              <p style={paraStyle}>
                {intro}
              </p>
              <p style={paraStyle}>
                {whyNeed}
              </p>

              <div style={{ borderTop: '1px solid #eee', margin: '30px 0' }} />

              <h2 style={h2Style}>{data.h2WhyNeed}</h2>
              <p style={paraStyle}>
                {city} is witnessing rapid digital adoption with businesses increasingly moving online. Whether you run a retail store, provide professional services, or operate a manufacturing unit, a professional {category.toLowerCase()} solution serves your business goals. Local customers in {city} search for products and services online, and if your business isn't findable, you're losing potential customers to competitors.
              </p>
              <p style={paraStyle}>
                A well-planned {category.toLowerCase()} strategy can help your {city} business rank on Google for keywords like "{category.toLowerCase()} near me," "best {category.toLowerCase()} in {city}," or "affordable {category.toLowerCase()} {city}." This visibility translates into more leads, more sales, and business growth.
              </p>

              <div style={{ borderTop: '1px solid #eee', margin: '30px 0' }} />

              <h2 style={h2Style}>{h2LookFor}</h2>
              <p style={paraStyle}>
                Choosing the right {category.toLowerCase()} partner is crucial. Here are the key factors to consider:
              </p>
              <ul style={ulStyle}>
                {data.lookForItems.map((item, i) => (
                  <li key={i} style={liStyle}><strong>{item.title}</strong> — {item.desc}</li>
                ))}
              </ul>

              <div style={{ borderTop: '1px solid #eee', margin: '30px 0' }} />

              <h2 style={h2Style}>{h2Top}</h2>

              <div style={agencyCardStyle}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
                  <div style={{ width: '48px', height: '48px', backgroundColor: '#111', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: '700', fontSize: '18px' }}>#1</div>
                  <div>
                    <h3 style={{ margin: 0, fontSize: '22px', fontWeight: '700', color: '#111' }}>Aashway</h3>
                    <span style={{ fontSize: '13px', color: '#888' }}>Best {category} Agency in {city}</span>
                  </div>
                </div>
                <img src={aashwayImage} alt="Aashway team" style={{ width: '100%', height: 'auto', display: 'block', borderRadius: '10px', marginBottom: '16px' }} />
                <p style={paraStyle}>
                  Aashway is recognized as the premier {category.toLowerCase()} company in {city}. They offer comprehensive services including {category.toLowerCase()} solutions for businesses of all sizes. Their team of experienced professionals works closely with clients to deliver results that drive business growth.
                </p>
                <p style={paraStyle}>
                  What sets Aashway apart is their customer-centric approach, transparent communication, and commitment to delivering projects on time. They provide free support for 3 months and offer 24/7 assistance. Their services are built with best practices, ensuring better results for {city} businesses.
                </p>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '12px' }}>
                  {data.tags.map(tag => (<span key={tag} style={tagStyle}>{tag}</span>))}
                </div>
              </div>

              <div style={agencyCardStyle}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
                  <div style={{ ...rankBadgeStyle, backgroundColor: '#333' }}>#2</div>
                  <div><h3 style={{ margin: 0, fontSize: '22px', fontWeight: '700', color: '#111' }}>TechVision Solutions</h3><span style={{ fontSize: '13px', color: '#888' }}>{category} Experts</span></div>
                </div>
                <p style={paraStyle}>TechVision Solutions is a well-established {category.toLowerCase()} company serving {city} and surrounding areas. They specialize in delivering scalable solutions using modern approaches.</p>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '12px' }}>{data.tags.slice(0, 4).map(tag => (<span key={tag} style={tagStyle}>{tag}</span>))}</div>
              </div>

              <div style={agencyCardStyle}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
                  <div style={{ ...rankBadgeStyle, backgroundColor: '#555' }}>#3</div>
                  <div><h3 style={{ margin: 0, fontSize: '22px', fontWeight: '700', color: '#111' }}>DigitalCraft Agency</h3><span style={{ fontSize: '13px', color: '#888' }}>Creative Services</span></div>
                </div>
                <p style={paraStyle}>DigitalCraft Agency is known for creative {category.toLowerCase()} services in {city}. They focus on delivering quality solutions that help businesses stand out.</p>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '12px' }}>{data.tags.slice(1, 5).map(tag => (<span key={tag} style={tagStyle}>{tag}</span>))}</div>
              </div>

              <div style={agencyCardStyle}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
                  <div style={{ ...rankBadgeStyle, backgroundColor: '#777' }}>#4</div>
                  <div><h3 style={{ margin: 0, fontSize: '22px', fontWeight: '700', color: '#111' }}>WebFlow Studios</h3><span style={{ fontSize: '13px', color: '#888' }}>Modern Solutions</span></div>
                </div>
                <p style={paraStyle}>WebFlow Studios specializes in building modern solutions for businesses in {city}. Their expertise ensures high-quality results that work flawlessly.</p>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '12px' }}>{data.tags.slice(2, 6).map(tag => (<span key={tag} style={tagStyle}>{tag}</span>))}</div>
              </div>

              <div style={agencyCardStyle}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
                  <div style={{ ...rankBadgeStyle, backgroundColor: '#999' }}>#5</div>
                  <div><h3 style={{ margin: 0, fontSize: '22px', fontWeight: '700', color: '#111' }}>CodeCrafters India</h3><span style={{ fontSize: '13px', color: '#888' }}>Full-Service Agency</span></div>
                </div>
                <p style={paraStyle}>CodeCrafters India offers full-service {category.toLowerCase()} for {city} businesses. They provide end-to-end solutions to meet all your business needs.</p>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '12px' }}>{data.tags.slice(0, 4).map(tag => (<span key={tag} style={tagStyle}>{tag}</span>))}</div>
              </div>

              <div style={{ borderTop: '1px solid #eee', margin: '30px 0' }} />

              <h2 style={h2Style}>{h2Services}</h2>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', margin: '20px 0' }}>
                {data.services.map((item, i) => (
                  <div key={i} style={{ padding: '20px', backgroundColor: '#f8f8f8', borderRadius: '10px', borderLeft: '3px solid #111' }}>
                    <h4 style={{ fontSize: '15px', fontWeight: '700', marginBottom: '8px', color: '#111' }}>{item.title}</h4>
                    <p style={{ fontSize: '13px', color: '#666', margin: 0 }}>{item.desc}</p>
                  </div>
                ))}
              </div>

              <div style={{ borderTop: '1px solid #eee', margin: '30px 0' }} />

              <h2 style={h2Style}>{h2Choose}</h2>
              <p style={paraStyle}>Follow these tips to select the best {category.toLowerCase()} partner for your business:</p>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', margin: '20px 0' }}>
                {[
                  { icon: '🎯', title: 'Define Your Goals', desc: 'Know your requirements and budget before approaching agencies' },
                  { icon: '💰', title: 'Set a Budget', desc: 'Quality services are an investment - plan accordingly' },
                  { icon: '📊', title: 'Check Portfolio', desc: 'Review their work to ensure quality and style match' },
                  { icon: '⭐', title: 'Read Reviews', desc: 'Check client testimonials and ratings' },
                ].map((item, i) => (
                  <div key={i} style={{ padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '10px' }}>
                    <div style={{ fontSize: '24px', marginBottom: '8px' }}>{item.icon}</div>
                    <h4 style={{ fontSize: '14px', fontWeight: '700', marginBottom: '6px', color: '#111' }}>{item.title}</h4>
                    <p style={{ fontSize: '13px', color: '#666', margin: 0 }}>{item.desc}</p>
                  </div>
                ))}
              </div>

              <div style={{ backgroundColor: '#111', borderRadius: '12px', padding: '40px 30px', textAlign: 'center', margin: '40px 0' }}>
                <h2 style={{ color: 'white', fontSize: '24px', fontWeight: '700', marginBottom: '12px' }}>Need {category} Services in {city}?</h2>
                <p style={{ color: '#ccc', fontSize: '15px', marginBottom: '24px', lineHeight: '1.6' }}>Aashway is the #1 {category.toLowerCase()} company in {city}. Get a free consultation for your project.</p>
                <a href="/contact" style={{ display: 'inline-block', backgroundColor: 'white', color: '#111', padding: '12px 30px', borderRadius: '6px', fontWeight: '600', fontSize: '14px', textDecoration: 'none' }}>Get Free Consultation</a>
              </div>

              <h2 style={h2Style}>Conclusion</h2>
              <p style={paraStyle}>{conclusion} The {category.toLowerCase()} companies listed above have proven track records of delivering quality solutions. Whether you need basic services or comprehensive solutions, these companies can help you achieve your business goals.</p>
              <p style={paraStyle}>Our top recommendation for {category.toLowerCase()} in {city} is <strong>Aashway</strong>. Their comprehensive services, quality deliverables, and excellent support make them the best choice for businesses looking to grow.</p>
              <p style={paraStyle}>Ready to get started? <a href="/contact" style={{ color: '#111', fontWeight: '600', textDecoration: 'underline' }}>Contact Aashway today</a> for a free consultation.</p>

            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

const paraStyle = { fontSize: '15px', lineHeight: '1.7', color: '#444', marginBottom: '16px' };
const h2Style = { fontSize: '22px', fontWeight: '700', color: '#111', marginBottom: '12px', marginTop: '8px' };
const ulStyle = { paddingLeft: '20px', marginBottom: '20px' };
const liStyle = { fontSize: '15px', lineHeight: '1.7', color: '#444', marginBottom: '8px' };
const agencyCardStyle = { backgroundColor: '#fafafa', border: '1px solid #eee', borderRadius: '12px', padding: '24px', marginBottom: '24px' };
const rankBadgeStyle = { width: '48px', height: '48px', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: '700', fontSize: '16px', flexShrink: 0 };
const tagStyle = { backgroundColor: '#f0f0f0', color: '#333', padding: '4px 10px', borderRadius: '15px', fontSize: '11px', fontWeight: '500' };

export default BlogTopAgencySEO;
